import graphql from "babel-plugin-relay/macro";
import AccountSetupModal from "components/modal/AccountSetupModal";
import { AccountSetupModalContainerUserQuery } from "components/modal/__generated__/AccountSetupModalContainerUserQuery.graphql";
import useSolanaContext from "hooks/useSolanaContext";
import { Suspense } from "react";
import { useLazyLoadQuery } from "react-relay";
import { Maybe } from "types/UtilityTypes";
import emptyFunction from "utils/emptyFunction";

const query = graphql`
  query AccountSetupModalContainerUserQuery($id: String!) {
    User_by_pk(id: $id) {
      id
    }
  }
`;

function AccountSetupModalContainerInner(): Maybe<JSX.Element> {
  const { anchorWallet } = useSolanaContext();
  const data = useLazyLoadQuery<AccountSetupModalContainerUserQuery>(query, {
    id: anchorWallet?.publicKey.toString() ?? "",
  });

  if (data.User_by_pk != null) {
    return null;
  }

  return <AccountSetupModal isShown onHide={emptyFunction} />;
}

/**
 * Displays AccountSetupModal if necessary
 */
export default function AccountSetupModalContainer(): Maybe<JSX.Element> {
  return (
    <Suspense fallback={<div />}>
      <AccountSetupModalContainerInner />
    </Suspense>
  );
}
